import React from 'react';

const Footer = () => (
  <footer className="bg-navy-blue text-gray-400 py-4 text-center text-sm ">
    <p>&copy; Copyright Atailia Technologies 2024</p>
  </footer>
);

export default Footer;